import React, { useEffect, useState } from "react";
import Layout from "../../../layout/Layout";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchVerifiedSalons } from "../../../redux/adminReducer";
import Loader from "../../../common/loader.jsx";
import { BsPersonFillSlash } from "react-icons/bs";
import Modal from "../../../common/modal.jsx";
import { toast } from "react-toastify";
import { API_PATH } from "../../../api/apiPath";
import { postApi } from "../../../api/axiosInstance.js";

function SalonList() {
  const { translations, dir } = useSelector((state) => state.language);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const status = useSelector((state) => state.admin.verifiedSalons.status);
  const salonsData = useSelector(
    (state) => state.admin.verifiedSalons?.data?.salons || []
  );
  const totalSalonData = useSelector(
    (state) => state.admin.verifiedSalons?.data?.totalData || 0
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("all");
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const [selectedSalon, setSelectedSalon] = useState(null);
  const itemsPerPage = 10;

  useEffect(() => {
    const b = {
      currentPage,
      filter,
    };
    dispatch(fetchVerifiedSalons(b));
  }, [dispatch, currentPage, filter]);

  useEffect(() => {
    if (status === "idle") {
      const b = {
        currentPage,
        filter,
      };
      dispatch(fetchVerifiedSalons(b));
    } else if (status === "loading") {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [dispatch, status, currentPage, filter]);

  const handleRowClick = (salonId) => {
    navigate(`/salon-list/salonlist-info/${salonId}`);
  };

  const [error, setError] = useState("");
  const handlePageChange = (event) => {
    const selectedPage = Number(event.target.value);

    if (selectedPage > totalPages) {
      setError(`Maximum value must be ${totalPages}`);
      // setCurrentPage(totalPages);
      return;
    }
    setCurrentPage(selectedPage);
    setError("");
  };
  const totalPages = Math.ceil(totalSalonData / itemsPerPage);

  const handleOpenBlockModal = (salon) => {
    setSelectedSalon(salon);
    setIsBlockModalOpen(true);
  };

  const handleConfirmBlock = async () => {
    if (!selectedSalon) return;
    try {
      setLoading(true);
      const res = await postApi(
        `${API_PATH.ADMIN.BLOCK_UNBLOCK_SALON}/${selectedSalon._id}`,
        ""
      );
      if (res.status === 201) {
        const b = {
          currentPage,
          filter,
        };
        dispatch(fetchVerifiedSalons(b));
      }
      if (res.data.data.is_blocked === true) {
        toast.success(translations.toaster.salonBlocked);
      } else {
        toast.success(translations.toaster.salonUnblocked);
      }
    } catch (error) {
      console.log(error);
      toast.error(translations.toaster.errorOccured);
    } finally {
      setLoading(false);
      setIsBlockModalOpen(false);
      setSelectedSalon(null);
    }
  };

  return (
    <>
      <Layout>
        <div className="min-h-screen w-full px-4 py-4">
          <section className="pt-1 grid grid-cols-2 items-center">
            <h1 className="text-xl font-bold text-white">
              {translations.salon.salons}
              <small className="text-2xl font-semibold text-gray-600"> |</small>
              <small className="font-normal text-gray-600">
                {" "}
                {translations.salon.salonsListManagement}
              </small>
            </h1>

            <div className="text-md text-white flex items-center justify-end space-x-1">
              <div className="rounded-full bg-[#5A189A] py-2 px-3">
                <Link to="/" className="text-white no-underline cursor-pointer">
                  {translations.salon.dashboard}
                </Link>
                <span className="mx-1">/</span>
                <span className="text-green-300">
                  {translations.salon.salons}
                </span>
              </div>
            </div>
          </section>

          <div className="p-4 w-full bg-gray-800 shadow-xl rounded mt-5">
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-2xl font-semibold text-white">
                    {translations.salon.salonsList}
                  </h2>
                  <div className="flex items-center">
                    <label htmlFor="salon-status" className="text-white px-2">
                      {translations.salon.filter}
                    </label>
                    <div className="relative">
                      <select
                        id="salon-status"
                        className="bg-gray-700 text-white rounded ps-2 pe-5 py-2 focus:outline-none w-full appearance-none"
                        value={filter}
                        onChange={(e) => {
                          const value =
                            e.target.value === "all"
                              ? "all"
                              : Number(e.target.value);
                          setFilter(value);
                          setCurrentPage(1);
                        }}
                      >
                        <option value="all">{translations.salon.all}</option>
                        <option value="301">
                          {translations.salon.available}
                        </option>
                        {/* <option value="busy">{translations.salon.busy}</option> */}
                        <option value="302">
                          {translations.salon.offline}
                        </option>
                      </select>

                      <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                        <svg
                          className="w-4 h-4 text-white"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                {salonsData.length === 0 ? (
                  <div className="flex h-64 items-center justify-center text-gray-500 dark:text-gray-400">
                    <p className="text-xl">{translations.salon.noData}</p>
                  </div>
                ) : (
                  <>
                    <div className="grid overflow-x-auto">
                      <table className="min-w-full bg-white shadow-md rounded p-2">
                        <thead className="bg-[#5A189A] text-white text-sm text-center">
                          <tr>
                            <th className="px-4 py-3">
                              {translations.salon.businessName}
                            </th>
                            <th className=" px-3 py-3">
                              {translations.salon_request.businessType}
                            </th>
                            <th
                              className="px-4 py-3"
                              style={{ direction: "ltr" }}
                            >
                              {translations.salon.phoneNumber}
                            </th>

                            <th className="px-4 py-3">
                              {translations.salon.commercialId}
                            </th>
                            <th className="px-4 py-3">
                              {translations.salon.contactAt}
                            </th>
                            <th className="px-4 py-3">
                              {translations.salon.status}
                            </th>
                            <th className="px-4 py-3">
                              {translations.salon.actions}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-gray-800 text-white">
                          {salonsData.map((salon, index) => (
                            <tr
                              key={index}
                              onClick={() => handleRowClick(salon._id)}
                              className={`hover:bg-gray-700 transition duration-200 cursor-pointer text-center ${
                                salon.is_blocked === false
                                  ? "text-white"
                                  : "text-red-500"
                              }`}
                            >
                              <td className={`px-4 py-3 `}>
                                {salon.business_name}
                              </td>
                              <td className={`px-4 py-3 `}>
                                {salon.business_type === 0
                                  ? translations.salon.individual
                                  : translations.salon.commercial}
                              </td>

                              <td
                                className={`px-4 py-3 `}
                                style={{ direction: "ltr" }}
                              >
                                {salon.business_phone}
                              </td>
                              <td className={`px-4 py-3 `}>
                                {salon.commercial_id}
                              </td>
                              <td className={`px-4 py-3 `}>{salon.email}</td>
                              <td
                                className={`px-4 py-3 font-semibold  ${
                                  salon.is_blocked
                                    ? "text-red-400"
                                    : salon.salon_status === 301
                                    ? "text-green-400"
                                    : salon.salon_status === 302
                                    ? "text-red-400"
                                    : "text-white"
                                } `}
                              >
                                <span className="bg-gray-600 px-3 py-1 rounded-full">
                                  {salon.is_blocked
                                    ? translations.salon.blocked
                                    : salon.salon_status === 301
                                    ? translations.salon.available
                                    : translations.salon.offline}
                                </span>
                              </td>
                              <td className="px-4 py-3 flex ">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenBlockModal(salon);
                                  }}
                                  className={`px-2 text-2xl ${
                                    salon.is_blocked === false
                                      ? "hover:text-red-500"
                                      : "hover:text-green-600"
                                  }`}
                                >
                                  <BsPersonFillSlash />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {/* Pagination Controls */}
                    <div className="mt-4 flex justify-between text-white">
                      <svg
                        className={`${
                          currentPage === 1
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        width={24}
                        height={24}
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        aria-disabled={currentPage === 1}
                      >
                        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                      </svg>
                      <span>
                        {translations.salon.page}
                        {totalPages > 1 ? (
                          <input
                            type="number"
                            name=""
                            id="pagination-jump"
                            className={
                              error
                                ? `mx-2 rounded-md border  ps-1 border-red  bg-gray-800 text-white shadow-card focus:border-primary`
                                : `mx-2 rounded-md border border-gray-300 ps-1  bg-gray-800 text-white shadow-card focus:border-primary`
                            }
                            min={1}
                            max={totalPages}
                            defaultValue={currentPage}
                            onChange={(e) => e.target.value}
                            onBlur={(e) => handlePageChange(e)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handlePageChange(e);
                              }
                            }}
                          />
                        ) : (
                          <span className="mx-1">{currentPage}</span>
                        )}
                        {translations.salon.of} {totalPages}
                      </span>
                      <svg
                        className={`${
                          currentPage === totalPages
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 320 512"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        aria-disabled={currentPage === totalPages}
                      >
                        <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                      </svg>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </Layout>
      <Modal
        isOpen={isBlockModalOpen}
        onClose={() => setIsBlockModalOpen(false)}
        width="w-[90%] max-w-md"
      >
        <div className="p-2 text-white">
          <h2 className="mb-4 text-xl font-bold">
            {selectedSalon?.is_blocked
              ? translations.salon.unblock
              : translations.salon.block}{" "}
            {translations.salon.salon}
          </h2>
          <p className="mb-6">
            {translations.salon.warning}{" "}
            {selectedSalon?.is_blocked
              ? translations.salon.unblock
              : translations.salon.block}{" "}
            <strong>{selectedSalon?.business_name}</strong>?
          </p>
          <div className="flex justify-end space-x-4">
            <button
              onClick={() => setIsBlockModalOpen(false)}
              className="px-4 py-2 rounded bg-gray-400 text-white hover:bg-gray-500"
            >
              {translations.salon.cancel}
            </button>
            <button
              onClick={handleConfirmBlock}
              className={`px-4 py-2 rounded text-white ${
                selectedSalon?.is_blocked
                  ? "bg-green-600 hover:bg-green-700"
                  : "bg-red-600 hover:bg-red-700"
              }`}
            >
              {selectedSalon?.is_blocked
                ? translations.salon.unblock
                : translations.salon.block}{" "}
              {translations.salon.salon}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SalonList;
